import { chatbotStateActions } from '.';

export const { toggleOpen, toggleFullScreen, setSize, setHistory, setActiveHistoryId } = chatbotStateActions;
